import React from "react";

const PartBrandSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M0.625 6.24967H8.75L9.375 7.49967H1.25L0.625 6.24967ZM1.45833 8.74967H9.58333L10.2083 9.99967H2.08333L1.45833 8.74967ZM15 15.4163C15.6917 15.4163 16.25 14.858 16.25 14.1663C16.25 13.4747 15.6917 12.9163 15 12.9163C14.3083 12.9163 13.75 13.4747 13.75 14.1663C13.75 14.858 14.3083 15.4163 15 15.4163ZM16.25 7.91634H14.1667V9.99967H17.8833L16.25 7.91634ZM6.66667 15.4163C7.35833 15.4163 7.91667 14.858 7.91667 14.1663C7.91667 13.4747 7.35833 12.9163 6.66667 12.9163C5.975 12.9163 5.41667 13.4747 5.41667 14.1663C5.41667 14.858 5.975 15.4163 6.66667 15.4163ZM16.6667 6.66634L19.1667 9.99967V14.1663H17.5C17.5 15.5497 16.3833 16.6663 15 16.6663C13.6167 16.6663 12.5 15.5497 12.5 14.1663H9.16667C9.16667 15.5497 8.04167 16.6663 6.66667 16.6663C5.28333 16.6663 4.16667 15.5497 4.16667 14.1663H2.5V11.2497H4.16667V12.4997H4.8C5.25833 11.9913 5.925 11.6663 6.66667 11.6663C7.40833 11.6663 8.075 11.9913 8.53333 12.4997H12.5V4.99967H2.5C2.5 4.07467 3.24167 3.33301 4.16667 3.33301H14.1667V6.66634H16.6667Z"
        fill="#006CDD"
      />
    </svg>
  );
};

export default PartBrandSvg;
